import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { useCan } from "components/Can";
import { useTypedQuery } from "hooks/useTypedQuery";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import { DealerReportQueryKeys } from "modules/DealerReports/queryKeys";
import { ApiInstance } from "utils/Api";

export const useDealerThresholds = (dealer_id: number) => {
  const { t } = useTranslation();
  const canListDealersReportThreshold = useCan(ACL_ACTIVITIES.List, ACL_RESOURCES.DealersReportThreshold);

  return useTypedQuery({
    queryKey: DealerReportQueryKeys.listThresholds(dealer_id),
    queryFn: async ({ baseUrl, endpoint, params }) => {
      try {
        return (await (await ApiInstance.post(endpoint, { ...params }, baseUrl)).data?.dealer_report_thresholds) ?? [];
      } catch (err) {
        toast.error(t("v8_failed_to_load_thresholds", "Failed to load thresholds"));
        throw err;
      }
    },
    enabled: canListDealersReportThreshold && Boolean(dealer_id)
  });
};
